// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__2TTnO","name":"ConsentHeader_name__1UIpk","birthday":"ConsentHeader_birthday__2Al7F","skeleton":"ConsentHeader_skeleton__3i-wR"};